/**
 * Métricas públicas del marketplace Coolliving.
 * Centralizadas para mantener coherencia entre landing, SEO y fallbacks estáticos.
 *
 * Última actualización: 2026-10-30 (inventario ~1.400–1.800 en /encuentratucoliving).
 * Revisar y actualizar tras cada scrape o sync importante del catálogo.
 */
export const SITE_METRICS = {
  roomCountLabel: '1.500+',
  roomCountLabelEn: '1,500+',
  roomCountNum: 1500,
  cityCount: 15,
  minPrice: '350€',
  minPriceMarketing: '350€',
  minPriceEn: '€350',
}
